// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { IRoleData, roleData } from 'src/app/features/role/models/role-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { activityDto, ActivityDto, IActivityDto } from './activity-dto.g';
import { functionDto, FunctionDto, IFunctionDto } from './function-dto.g';
import { IFunctionRefDto } from './function-ref-dto.g';

export const roleDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    domainAssignable: 'domainAssignable',
    inactive: 'inactive',
    deleted: 'deleted',
    activitiesDto: 'activitiesDto',
    functionsDto: 'functionsDto',
} as const;

export type TRoleDto = (typeof roleDto)[keyof typeof roleDto];

export const roleDtoConstraints = {
    name: { required: true },
    guid: { required: true },
} as const;

export type TRoleDtoConstraints = typeof roleDtoConstraints;

export interface IRoleDto extends ILevelDomainDto {
    [roleDto.guid]: string | null;
    [roleDto.nr]: number | null;
    [roleDto.name]: string | null;
    [roleDto.domainAssignable]: boolean | null;
    [roleDto.inactive]: boolean | null;
    [roleDto.deleted]: boolean | null;
    [roleDto.activitiesDto]: IActivityDto[] | null;
    [roleDto.functionsDto]: IFunctionRefDto[] | null;
}

export class RoleDto
    implements IRoleDto
{
    [roleDto.guid]: string | null = null;
    [roleDto.nr]: number | null = null;
    [roleDto.name]: string | null = null;
    [roleDto.domainAssignable]: boolean | null = null;
    [roleDto.inactive]: boolean | null = null;
    [roleDto.deleted]: boolean | null = null;
    [roleDto.activitiesDto]: IActivityDto[] | null = null;
    [roleDto.functionsDto]: IFunctionRefDto[] | null = null;

    private constructor(modelData?: IRoleData, includeRefs = true) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[roleDto.guid] = modelData[roleData.guid];
        this[roleDto.nr] = modelData[roleData.nr];
        this[roleDto.name] = modelData[roleData.name];
        this[roleDto.domainAssignable] = modelData[roleData.domainAssignable] ?? false;
        this[roleDto.deleted] = modelData[roleData.deleted];
        this[roleDto.inactive] = modelData[roleData.inactive];

        if (!includeRefs) return;

        this[roleDto.activitiesDto] = modelData[roleData.activitiesData]
            ?.map(item => ActivityDto.create(item, false))
            .filter((a): a is IActivityDto => a !== null)
            .sort((a, b) => (a[activityDto.name] ?? '').localeCompare(b[activityDto.name] ?? ''))
            ?? null;
        this[roleDto.functionsDto] = modelData[roleData.functionsData]
            ?.map(item => FunctionDto.create(item))
            .filter((a): a is IFunctionDto => a !== null)
            .sort((a, b) => (a[functionDto.name] ?? '').localeCompare(b[functionDto.name] ?? ''))
            ?? null;
}

    static create(modelData?: IRoleData | null, includeRefs = true): IRoleDto | null {
        return modelData ? new RoleDto(modelData, includeRefs) : null;
    }
}
